import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (uuid) => {
	return fetch(Methods.GET, EndPoints.URL_ASSETS_DATA.replace(':uuid', uuid), null, null, true);
};
